/*
 * @Description:
 * @Author:
 * @Date: 2022-04-20 16:23:49
 * @LastEditTime: 2023-09-25 10:42:46
 * @LastEditors: guohongyuan
 * @Usage:
 */
import Axios from 'axios';
import qs from 'qs';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
import { Message } from 'element-ui';
import { serialize } from '@/util/util';
import errorCode from '@/util/errorCode';
import { getStore } from '@/util/store';
import Router from '@/plugins/router';
// import { config } from 'vue/types/umd';

var env = process.env.NODE_ENV;
Axios.defaults.timeout = 30000;
// 返回其他状态吗
Axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
// 跨域请求，允许保存cookie
Axios.defaults.withCredentials = true;
Axios.withCredentials = true;
NProgress.configure({
  showSpinner: false,
});
let prodPoxy = '';
// if (env == 'production') {
//   prodPoxy = '/service'
// }
if (env == 'development') {
  prodPoxy = '';
} else {
  prodPoxy = '/service';
}

// HTTPrequest拦截
Axios.interceptors.request.use(
  (config) => {


    // config.headers = {  //设置头文件
    //   "Authorization": 'Bearer ' + getStore({ name: 'accessToken' })
    // }
    config.isResponseType && (config.responseType = 'blob');
    let { url } = config;
    if (process.env.NODE_ENV == "production") {
      let spliceStr =
        url.split("/")[1] && url.split("/")[1] == "api"
          ? "/service"
          : "/center";
      //整合用户9100
      if (url.indexOf('middle-user/page-list') > -1) {
        spliceStr = "/center";
      }
      config.url = spliceStr + config.url;
    }

    NProgress.start(); // start progress bar
    // config.loading && loading.start()
    // headers中配置serialize为true开启序列化
    if (config.method === 'post' && config.headers.serialize) {
      config.data = serialize(config.data);
      delete config.data.serialize;
    }

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }
    return config;
  },
  (error) => {
    // loading.stop()
    return Promise.reject(error);
  }
);

// HTTPresponse拦截
Axios.interceptors.response.use(
  (res) => {

    if (
      res.headers['content-type'] == 'image/png' ||
      res.headers['content-type'] == 'image/gif'
    ) {
      let url = window.URL.createObjectURL(new Blob([res.data]));
      let infor = {
        data: {
          statusCode: 200,
        },
        code: 0,
        url: url,
      };
      return infor;
    }
    if (res.headers['content-type'] == 'application/vnd.ms-excel') {
      return res;
    }
    // if (res.headers["content-type"] == "application/json; charset=utf-8") {
    //   return res;

    // }
    NProgress.done();
    // loading.stop()
    const status = Number(res.status) || 200;
    
    var message = res.data.msg || errorCode[status] || errorCode['default'];
    const resConfig = res.config || {};

    if (res.data.statusCode !== 200 ) {
      Message({
        message: res.data.errors,
        type: 'error',
      });
      return Promise.reject(new Error(message));
    }

    if (status !== 200 || res.data.code === 1) {
      Message({
        message: message,
        type: 'error',
      });
      return Promise.reject(new Error(message));
    }

    return res;
  },
  (error) => {
    NProgress.done();
    // loading.stop()
    return Promise.reject(new Error(error));
  }
);
export default Axios;
